import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { completeParticipantClaim, completeParticipantRecovery } from '../services/harvestingService';

function takeTokenFromFragment() {
  const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const token = fragment.get('token') || '';
  if (token) window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
  return token;
}

export default function HarvestParticipantAccessPage() {
  const location = useLocation();
  const recovery = location.pathname === '/recover-harvest';
  const [token] = useState(takeTokenFromFragment);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const title = useMemo(() => recovery ? 'Reset your harvesting account password' : 'Claim your harvesting profile', [recovery]);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    if (!token) {
      setError('This one-time handover link is missing or has already been removed. Contact the community staff member who prepared it.');
      return;
    }
    if (password.length < 8 || password !== confirmPassword) {
      setError(password !== confirmPassword ? 'The passwords do not match.' : 'Choose a password of at least 8 characters.');
      return;
    }
    setBusy(true);
    try {
      const result = recovery
        ? await completeParticipantRecovery({ token, password })
        : await completeParticipantClaim({ token, email, password });
      setSuccess(result.data.message);
      setPassword('');
      setConfirmPassword('');
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'The handover could not be completed. Contact community staff for a new link.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main style={{ maxWidth: 560, margin: '48px auto', padding: 24, border: '1px solid #d1d5db', borderRadius: 10, background: '#fff' }}>
      <h1>{title}</h1>
      {!token && <p role="alert" style={{ color: '#991b1b' }}>This one-time handover link is missing or has already been removed. Contact the community staff member who prepared it.</p>}
      <p>
        {recovery
          ? 'Only you should enter your new password here. Community staff will not see or set it.'
          : 'Use the email address confirmed for this invitation, then choose your own password. CIP does not automatically send or verify email in this handover flow.'}
      </p>
      {error && <p role="alert" style={{ color: '#991b1b' }}>{error}</p>}
      {success ? (
        <div role="status">
          <p>{success}</p>
          <Link to="/login">Go to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit}>
          {!recovery && (
            <label style={{ display: 'block', margin: '12px 0' }}>
              Invitation email
              <input required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} style={{ display: 'block', width: '100%', padding: 9, marginTop: 5 }} />
            </label>
          )}
          <label style={{ display: 'block', margin: '12px 0' }}>
            {recovery ? 'New password' : 'Choose a password'}
            <input required minLength={8} type="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} style={{ display: 'block', width: '100%', padding: 9, marginTop: 5 }} />
          </label>
          <label style={{ display: 'block', margin: '12px 0' }}>
            Confirm password
            <input required minLength={8} type="password" autoComplete="new-password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} style={{ display: 'block', width: '100%', padding: 9, marginTop: 5 }} />
          </label>
          <button type="submit" disabled={busy || !token} style={{ padding: '9px 16px' }}>
            {busy ? 'Working…' : recovery ? 'Set new password' : 'Claim profile'}
          </button>
        </form>
      )}
      <p style={{ marginTop: 20, color: '#64748b', fontSize: 13 }}>
        Handover links are single-use and expire. If you did not request this link, do not use it; contact your community administrator.
      </p>
    </main>
  );
}
